import React, { useState, useEffect } from "react";
import {authAction, authHandlingErrors, hideHelperAction} from "../../../../redux/actions/auth";
import { TextField, Button } from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import style from "./Common.module.css";
import { withRouter } from "react-router-dom";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    marginBottom: "26px"
  }
}));

const LoginContent = ({
  backToSignUp,
  onOpenForgotModal,
  onCLose,
  authAction,
  authHandlingErrors,
  errors = {},
  history,
  hideHelperAction
}) => {
  const classes = useStyles();

  const [userObj, setUserObj] = useState({
    email: "",
    password: ""
  });


  useEffect(() => {
    const listener = event => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        handleLogin();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userObj, errors]);


  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      authHandlingErrors({});
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = event => {
    const errorsCopy = JSON.parse(JSON.stringify(errors));

    const { value, name } = event.target;

    const copyUserObj = { ...userObj };

    copyUserObj[name] = value;

    setUserObj(copyUserObj);

    if (errorsCopy && errorsCopy[name]) {
      delete errorsCopy[name];
      authHandlingErrors(errorsCopy);
    }
    if (errorsCopy && errorsCopy.error) {
      delete errorsCopy.error;
      authHandlingErrors(errorsCopy);
    }
  };

  const handleLogin = () => {
    const errorsObj = {};
    if (userObj && userObj.email === "") {
      errorsObj.email = "Email field is requierd";
    }
    if (userObj && userObj.password === "") {
      errorsObj.password = "Password field is requierd";
    }

    if (
      (userObj && userObj.email === "") ||
      (userObj && userObj.password === "")
    ) {
      authHandlingErrors(errorsObj);
    }

    if (userObj.password !== "" && userObj.email !== "") {
      hideHelperAction(false);
      authAction(userObj, onCLose);
    }
  };

  return (
    <>
      <div className={style.wrapper}>
        <TextField
          error={errors && errors.email ? true : false}
          className={classes.root}
          label="Email"
          variant="outlined"
          name="email"
          onChange={handleChange}
          helperText={errors && errors.email ? errors.email : ""}
        />
        <TextField
          error={errors && errors.password ? true : false}
          className={classes.root}
          label="Password"
          variant="outlined"
          type="password"
          name="password"
          onChange={handleChange}
          helperText={errors && errors.password ? errors.password : ""}
        />

        {errors.error && <div className={style.loginError}>{errors.error}</div>}

        <div className={style.linkBlock}>
          <button
            type="button"
            className={style.link}
            onClick={onOpenForgotModal}
          >
            <span className={style.linkText}>Forgot Password</span>
          </button>
        </div>
      </div>
      <div className={style.btnGroup}>
        <Button onClick={backToSignUp}>Sign Up</Button>
        <Button onClick={ handleLogin}>Login</Button>
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {
    errors: state.auth.errors
  };
};
const mapDispatchToProps = {
  authAction,
  authHandlingErrors,
  hideHelperAction
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LoginContent)
);
